// extracted by mini-css-extract-plugin
export default {"match_screen_height":"wildCard_match_screen_height__BJ46z","padding_mobile":"wildCard_padding_mobile__EjdBh"};